import { Skeleton } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { DatePicker } from 'components/atoms/date-picker';
import { PLACEHOLDER } from 'constant';
import { TemplateDueDatePayload } from 'data/templates/api';
import { useTemplateDueDateQuery } from 'queries/templates/common';

interface Props {
  data: Partial<TemplateDueDatePayload>;
}

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

export const EstimatedDueDate: FC<Props> = ({ data }) => {
  const { data: result, isLoading } = useTemplateDueDateQuery(data);

  return isLoading ? (
    <Skeleton.Input style={{ width: '150px' }} active size="default" />
  ) : (
    <StyledDatePicker
      disabled
      placeholder={PLACEHOLDER}
      value={result && moment(result.dueDate)}
    />
  );
};
